(function(){'use strict';function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}!function(){if(!window.customElements.get("bundle-set")){var e=function(e){_inherits(a,e);var t=_createSuper(a);function a(){return _classCallCheck(this,a),t.apply(this,arguments)}return _createClass(a,[{key:"connectedCallback",value:function(){this.formId=this.dataset.productFormId,this.form=this.formId?document.getElementById(this.formId):null,this.submitButton=this.form?this.form.querySelector('button[type="submit"]'):null,this.onResizeBound=this.updateColorOverflow.bind(this),this.itemIdsInput=this.querySelector('[data-bundle-property="item-ids"]'),this.itemHandlesInput=this.querySelector('[data-bundle-property="item-handles"]'),this.addEventListener("click",this.onClick.bind(this)),window.addEventListener("resize",this.onResizeBound),this.updateColorOverflow(),this.syncProperties();}},{key:"disconnectedCallback",value:function(){this.onResizeBound&&window.removeEventListener("resize",this.onResizeBound);}},{key:"onClick",value:function(e){var t=e.target.closest("[data-bundle-color-more]");if(t&&this.contains(t))this.onColorMoreClick(t);else {var a=e.target.closest("[data-bundle-color-option]");if(a&&this.contains(a))this.onColorSelect(a);else {var i=e.target.closest("[data-bundle-size]");i&&this.contains(i)&&this.onSizeSelect(i);}}}},{key:"onColorSelect",value:function(e){if(!e.hasAttribute("disabled")){var t=e.closest("[data-bundle-item]");if(t){t.querySelectorAll("[data-bundle-color-option].is-active").forEach((function(e){e.classList.remove("is-active"),e.removeAttribute("aria-current");})),e.classList.add("is-active"),e.setAttribute("aria-current","true");var i=t.querySelector(".bundle-set__item-image"),s=t.querySelector("[data-item-title]"),r=t.querySelector("[data-item-link]"),l=t.querySelector("[data-color-name]");i&&e.dataset.image&&(i.src=e.dataset.image,e.dataset.image2x?(i.srcset="".concat(e.dataset.image," 1x, ").concat(e.dataset.image2x," 2x"),i.sizes="72px"):i.removeAttribute("srcset")),s&&e.dataset.title&&(s.textContent=e.dataset.title),l&&e.dataset.colorName&&(l.textContent=e.dataset.colorName),a.updateSizeGuideButton(t,e.dataset.sizeGuideDrawerId||""),e.dataset.url&&(s&&(s.href=e.dataset.url),r&&(r.href=e.dataset.url)),t.dataset.selectedProductHandle=e.dataset.productHandle||"";var o=e.querySelector("[data-bundle-product-json]"),n=a.parseProductJson(o);n&&a.rebuildSizeOptions(t,n),!t.dataset.selectedVariantId&&e.dataset.variantId&&(t.dataset.selectedVariantId=e.dataset.variantId),this.updateColorOverflow(),this.syncProperties();}}}},{key:"onSizeSelect",value:function(e){if(!e.hasAttribute("disabled")){var t=e.closest("[data-bundle-item]");t&&(t.querySelectorAll("[data-bundle-size].is-active").forEach((function(e){e.classList.remove("is-active");})),e.classList.add("is-active"),t.dataset.selectedVariantId=e.dataset.variantId||"",t.dataset.itemSoldout="true"===e.dataset.available?"false":"true",t.classList.toggle("is-soldout","true"===t.dataset.itemSoldout),a.updateSelectedSizeValue(t,e.dataset.sizeValue||""),this.syncProperties());}}},{key:"syncProperties",value:function(){var e=Array.from(this.querySelectorAll("[data-bundle-item]")),t=[],a=[],i=!1;e.forEach((function(e){var s=e.dataset.selectedVariantId,r=e.dataset.selectedProductHandle;s&&t.push(s),r&&a.push(r),"true"===e.dataset.itemSoldout&&(i=!0);})),this.itemIdsInput&&(this.itemIdsInput.value=t.join(",")),this.itemHandlesInput&&(this.itemHandlesInput.value=a.join(",")),this.submitButton&&(this.submitButton.disabled="true"===this.dataset.setSoldout||i||t.length!==e.length);}},{key:"onColorMoreClick",value:function(e){var t=e.closest("[data-bundle-color-list]");t&&(t.dataset.expanded="true",this.updateColorOverflow());}},{key:"updateColorOverflow",value:function(){var e=window.matchMedia("(max-width: 699px)").matches;this.querySelectorAll("[data-bundle-color-list]").forEach((function(t){var a=Number(t.dataset.visibleDesktop||9),i=Number(t.dataset.visibleMobile||7),s=e?i:a,r="true"===t.dataset.expanded,l=Array.from(t.querySelectorAll("[data-bundle-color-option]")),o=t.querySelector("[data-bundle-color-more]"),n=0;l.forEach((function(e,t){var a=Number(e.dataset.colorOptionIndex||t+1),i=e.classList.contains("is-active"),l=!r&&a>s&&!i;e.hidden=l,l&&(n+=1);})),o&&(r||n<=0?o.hidden=!0:(o.hidden=!1,o.textContent="+".concat(n)));}));}}],[{key:"rebuildSizeOptions",value:function(e,t){var i,s=e.querySelector("[data-bundle-size-picker]");if(s&&Array.isArray(t.variants)){var r=null===(i=s.querySelector("[data-bundle-size].is-active"))||void 0===i?void 0:i.dataset.sizeValue,l=null;if(s.innerHTML="",t.variants.forEach((function(e){var t=e.option1||e.title,a=document.createElement("button");a.type="button",a.className="bundle-set__size",a.dataset.bundleSize="",a.dataset.sizeValue=t,a.dataset.variantId=String(e.id),a.dataset.available=String(Boolean(e.available)),a.textContent=t,e.available||(a.disabled=!0),l||r&&t===r&&e.available&&(l=e,a.classList.add("is-active")),s.appendChild(a);})),!l&&(l=t.variants.find((function(e){return e.available}))||t.variants[0])){var o=s.querySelector('[data-variant-id="'.concat(l.id,'"]'));o&&o.classList.add("is-active");}if(s.hidden=t.variants.length<=1,l){var n=e;n.dataset.selectedVariantId=String(l.id),n.dataset.itemSoldout=l.available?"false":"true",n.classList.toggle("is-soldout","true"===n.dataset.itemSoldout),a.updateSelectedSizeValue(n,l.option1||l.title||"");}}}},{key:"parseProductJson",value:function(e){if(!e)return null;try{return JSON.parse(e.textContent)}catch(e){return null}}},{key:"updateSelectedSizeValue",value:function(e,t){var a=e.querySelector("[data-bundle-size-value]");a&&t&&(a.textContent=t);}},{key:"updateSizeGuideButton",value:function(e,t){var a=e.querySelector("[data-bundle-size-guide-button]");a&&(t?(a.hidden=!1,a.setAttribute("aria-controls",t)):(a.hidden=!0,a.removeAttribute("aria-controls")));}}]),a}(_wrapNativeSuper(HTMLElement));window.customElements.define("bundle-set",e);}}();})();